import { router } from "_/router/router";

import { mapActions, mapGetters } from "vuex";

export default {
    /**
     * Define props
     *
     * @type  {Object}
     */
    props: {
        vuexModule: {
            required: true,
            type: String,
        },
    },

    /**
     * Set the computed variables
     *
     * @type  {object}
     */
    computed: {
        ...mapGetters({
            ui: "ui/ui",
            generator: "generator/generator",
            photonModule: "photonModule/photonModule",
            admin: "admin",
        }),

        /**
         * check if selected module has data overdraft
         *
         * @return  {object}
         */
        dataOverdraft() {
            let selectedModuleTableName = this.admin.selectedModule.table_name;
            let selectedModuleId = this.photonModule.moduleTableNameToIdMap[
                selectedModuleTableName
            ];
            let isOverdraft = this.photonModule.moduleIdToModuleObjectMap[
                selectedModuleId
            ].overdraft_status;
            return isOverdraft;
        },

        /**
         * Create the admin getter based on the vuexModule prop
         *
         * @return  {object}
         */
        admin() {
            const getterName = `${this.vuexModule}/${this.vuexModule}`;

            return this.$store.getters[getterName];
        },
    },

    /**
     * Set the methods
     *
     * @type  {Object}
     */
    methods: {
        ...mapActions("ui", ["triggerCreateMode"]),

        /**
         * Triggers the create mode
         *
         * @return  {void}
         */
        createNewEntry() {
            this.triggerCreateMode();
        },

        /**
         * Triggers the create mode
         *
         * @return  {void}
         */
        createNewModule() {
            router.push("/generator");
        },
    },
};
